var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-layout",
    { staticClass: "ai-assistant__wrapper" },
    [
      _c(
        "a-layout-header",
        [
          _c(
            "div",
            { staticClass: "ai-assistant__header__main" },
            [
              _c("div", { staticClass: "ai-assistant__header__title" }, [
                _vm._v(_vm._s(_vm.session && _vm.session.title)),
              ]),
              _c("a-space", { staticClass: "ai-assistant__header__info" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.session &&
                        (_vm.session.chats.length || _vm.session.msg_count)
                    ) + "条对话"
                  ),
                ]),
                _c("span", [
                  _vm._v(_vm._s(_vm.session && _vm.session.updated_at)),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "a-space",
            { staticClass: "ai-assistant__header__actions" },
            [
              _vm.session &&
              _vm.session.type === "teamSession" &&
              _vm.session.teamPrompts &&
              _vm.session.teamPrompts.length &&
              _vm.session.chats &&
              _vm.session.chats.length > 0
                ? _c(
                    "a-popover",
                    {
                      attrs: { title: "选择主题" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "content",
                            fn: function () {
                              return [
                                _c("AiAssistantTeamPrompts", {
                                  attrs: {
                                    prompts:
                                      (_vm.session &&
                                        _vm.session.teamPrompts) ||
                                      [],
                                  },
                                  on: { click: _vm.handlePromptClick },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3408899883
                      ),
                    },
                    [_c("a", [_vm._v("选择其他主题")])]
                  )
                : _vm._e(),
              _vm.prompts.length &&
              _vm.session &&
              _vm.session.type !== "teamSession" &&
              _vm.session.chats &&
              _vm.session.chats.length > 0
                ? _c(
                    "a-popover",
                    {
                      attrs: { title: "选择主题" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "content",
                            fn: function () {
                              return [
                                _c("ai-assistant-prompts", {
                                  on: { click: _vm.handlePromptClick },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3712624457
                      ),
                    },
                    [_c("a", [_vm._v("选择其他主题")])]
                  )
                : _vm._e(),
              _vm.session && _vm.session.type !== "teamSession"
                ? _c("a-tooltip", { attrs: { title: "转为团队话题" } }, [
                    _c(
                      "a",
                      {
                        staticClass: "ai-assistant__header__action",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.convertToTeamTopic.apply(null, arguments)
                          },
                        },
                      },
                      [_c("a-icon", { attrs: { type: "usergroup-add" } })],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.session && _vm.session.type === "teamSession"
                ? [
                    _c(
                      "a",
                      { staticClass: "ai-assistant__header__action" },
                      [
                        _c(
                          "a-popover",
                          {
                            attrs: { placement: "bottom", trigger: "hover" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "team-members-list" },
                                        [
                                          _vm.session &&
                                          _vm.session.partakeUsers &&
                                          _vm.session.partakeUsers.length > 0
                                            ? _c(
                                                "div",
                                                _vm._l(
                                                  _vm.session.partakeUsers,
                                                  function (member, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass:
                                                          "team-member-item",
                                                      },
                                                      [
                                                        _c(
                                                          "a-avatar",
                                                          {
                                                            style: {
                                                              backgroundColor:
                                                                _vm.getAvatarColor(
                                                                  member.user_name
                                                                ),
                                                            },
                                                            attrs: {
                                                              icon: "user",
                                                              size: 14,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getAvatarText(
                                                                  member.user_name
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "team-member-name",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                member.user_name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "team-member-empty",
                                                },
                                                [_vm._v("暂无团队成员")]
                                              ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2966744406
                            ),
                          },
                          [_c("a-icon", { attrs: { type: "team" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("a-tooltip", { attrs: { title: "添加团队成员" } }, [
                      _c(
                        "a",
                        {
                          staticClass: "ai-assistant__header__action",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.handleAddTeamMember.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [_c("a-icon", { attrs: { type: "user-add" } })],
                        1
                      ),
                    ]),
                    _c(
                      "a-dropdown",
                      [
                        _c(
                          "a",
                          {
                            staticClass: "ai-assistant__header__action",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                              },
                            },
                          },
                          [_c("a-icon", { attrs: { type: "setting" } })],
                          1
                        ),
                        _c(
                          "a-menu",
                          { attrs: { slot: "overlay" }, slot: "overlay" },
                          [
                            _c(
                              "a-menu-item",
                              {
                                key: "edit",
                                on: { click: _vm.handleEditTeamTopic },
                              },
                              [
                                _c("a-icon", { attrs: { type: "edit" } }),
                                _vm._v("编辑话题 "),
                              ],
                              1
                            ),
                            _c(
                              "a-menu-item",
                              {
                                key: "delete",
                                on: { click: _vm.handleDeleteTeamTopic },
                              },
                              [
                                _c("a-icon", { attrs: { type: "delete" } }),
                                _vm._v("删除话题 "),
                              ],
                              1
                            ),
                            _c(
                              "a-menu-item",
                              {
                                key: "exit",
                                on: { click: _vm.handleExitTeamTopic },
                              },
                              [
                                _c("a-icon", { attrs: { type: "logout" } }),
                                _vm._v("退出话题 "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "a-tooltip",
                { attrs: { title: _vm.fullscreen ? "还原" : "全屏" } },
                [
                  _c(
                    "a",
                    {
                      staticClass: "ai-assistant__header__action",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.triggerFullscreen.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("a-icon", {
                        attrs: {
                          type: _vm.fullscreen
                            ? "fullscreen-exit"
                            : "fullscreen",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "a-layout-content",
        { ref: "content" },
        [
          _vm.session &&
          _vm.session.type === "teamSession" &&
          _vm.session.chats &&
          _vm.session.chats.length === 0
            ? _c("AiAssistantTeamPrompts", {
                attrs: {
                  prompts: (_vm.session && _vm.session.teamPrompts) || [],
                },
                on: { click: _vm.handlePromptClick },
              })
            : _vm._e(),
          _vm.session &&
          _vm.session.type === "session" &&
          _vm.session.chats &&
          _vm.session.chats.length === 0
            ? _c("ai-assistant-prompts", {
                on: { click: _vm.handlePromptClick },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "ai-assistant-chats" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.session && _vm.session.loading,
                      expression: "session && session.loading",
                    },
                  ],
                  staticClass: "ai-assistant-chat ai-assistant-chat--assistant",
                },
                [
                  _c("div", { staticClass: "ai-assistant-chats__loading" }, [
                    _c("div", {
                      staticClass: "ai-assistant-chats__loading-dot",
                    }),
                    _c("div", {
                      staticClass: "ai-assistant-chats__loading-dot",
                    }),
                    _c("div", {
                      staticClass: "ai-assistant-chats__loading-dot",
                    }),
                  ]),
                  _c("div", { staticClass: "ai-assistant-chat__content" }, [
                    _vm._v("思考中..."),
                  ]),
                ]
              ),
              _vm._l(
                (_vm.session && _vm.session.chats) || [],
                function (message, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: {
                        "ai-assistant-chat": true,
                        "ai-assistant-chat--user": message.source === 1,
                        "ai-assistant-chat--assistant": message.source === 2,
                      },
                    },
                    [
                      message.source === 3
                        ? _c("a-divider", [_vm._v("清除上下文")])
                        : _vm._e(),
                      message.source !== 3
                        ? _c(
                            "div",
                            { staticClass: "ai-assistant-chat__datetime" },
                            [
                              _vm._v(_vm._s(message.created_at)),
                              message.source === 1
                                ? _c(
                                    "span",
                                    { staticStyle: { "margin-left": "4px" } },
                                    [_vm._v(_vm._s(message.user_name))]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      message.source !== 3
                        ? _c(
                            "div",
                            { staticClass: "ai-assistant-chat__content" },
                            [
                              message.think
                                ? _c("div", {
                                    staticClass: "ai-assistant-chat__think",
                                    domProps: {
                                      innerHTML: _vm._s(message.think),
                                    },
                                  })
                                : _vm._e(),
                              message.source === 1
                                ? _c("div", {
                                    staticClass: "ai-assistant-chat__html",
                                    domProps: {
                                      innerHTML: _vm._s(message.content),
                                    },
                                  })
                                : _vm._e(),
                              message.source === 2
                                ? _c("div", {
                                    staticClass: "ai-assistant-chat__markdown",
                                    domProps: {
                                      innerHTML: _vm._s(message.markdown),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      message.source === 2
                        ? _c(
                            "div",
                            { staticClass: "ai-assistant-chat__tools" },
                            [
                              _c(
                                "a-space",
                                [
                                  _c(
                                    "a-tooltip",
                                    { attrs: { title: "复制" } },
                                    [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.copyText(
                                                message.content
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a-icon", {
                                            attrs: { type: "copy" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "a-tooltip",
                                    { attrs: { title: "引用" } },
                                    [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.quoteMessage(message)
                                            },
                                          },
                                        },
                                        [
                                          _c("a-icon", {
                                            attrs: { type: "message" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "a-tooltip",
                                    { attrs: { title: "重新生成" } },
                                    [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.reSend(message)
                                            },
                                          },
                                        },
                                        [
                                          _c("a-icon", {
                                            attrs: { type: "redo" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "a-layout-footer",
        [
          _c(
            "a-space",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "a-select",
                {
                  staticStyle: { width: "135px" },
                  attrs: { "dropdown-match-select-width": false },
                  model: {
                    value: _vm.modelId,
                    callback: function ($$v) {
                      _vm.modelId = $$v
                    },
                    expression: "modelId",
                  },
                },
                _vm._l(_vm.models, function (item) {
                  return _c(
                    "a-select-option",
                    { key: item.model_id, attrs: { value: item.model_id } },
                    [_vm._v(" " + _vm._s(item.model_name) + " ")]
                  )
                }),
                1
              ),
              _c(
                "a-button",
                { attrs: { type: "default" }, on: { click: _vm.partition } },
                [_vm._v("清除上下文")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { ref: "textarea", staticClass: "ai-assistant__textarea" },
            [
              _vm.quotedMessages.length > 0
                ? _c(
                    "div",
                    { staticClass: "ai-assistant__quote" },
                    [
                      _vm._l(_vm.quotedMessages, function (quote, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "ai-assistant__quote-item",
                          },
                          [
                            _c("div", {
                              staticClass: "ai-assistant__quote-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.processQuoteContent(
                                    quote.markdown || quote.content
                                  )
                                ),
                              },
                            }),
                            _c(
                              "a-button",
                              {
                                staticClass: "ai-assistant__quote-close",
                                attrs: { type: "link" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeQuote(index)
                                  },
                                },
                              },
                              [_c("a-icon", { attrs: { type: "close" } })],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        { staticClass: "ai-assistant__quote-actions" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "link", size: "small" },
                              on: { click: () => (_vm.quotedMessages = []) },
                            },
                            [_vm._v("清除全部引用")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _c("a-input", {
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 6, maxRows: 8 },
                  disabled:
                    _vm.session &&
                    (_vm.session.streaming || _vm.session.loading),
                  placeholder:
                    "这里是AI智能问答，您可以进行和AI自由对话或获取建议。如需查询ERP数据，请前往“智能体”",
                },
                on: { keydown: _vm.handleSendMessage },
                model: {
                  value: _vm.inputValue,
                  callback: function ($$v) {
                    _vm.inputValue = $$v
                  },
                  expression: "inputValue",
                },
              }),
              _vm.session && !_vm.session.streaming
                ? _c(
                    "a-button",
                    {
                      staticClass: "ai-assistant__textarea__button",
                      attrs: { type: "primary", disabled: _vm.session.loading },
                      on: { click: _vm.sendMessage },
                    },
                    [_vm._v(" 发送 ")]
                  )
                : _c(
                    "a-button",
                    {
                      staticClass: "ai-assistant__textarea__button",
                      attrs: { type: "danger" },
                      on: { click: _vm.stopMessage },
                    },
                    [
                      _c("i", {
                        staticStyle: {
                          "margin-right": "4px",
                          display: "inline-block",
                          width: "11px",
                          height: "11px",
                          "background-color": "#fff",
                        },
                      }),
                      _vm._v("停止 "),
                    ]
                  ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "5px",
                "margin-bottom": "-5px",
                display: "flex",
                "align-items": "center",
              },
            },
            [
              _c(
                "span",
                { staticStyle: { color: "#0B1019", "font-size": "12px" } },
                [
                  _vm._v(
                    "剩余搜索量" +
                      _vm._s((_vm.quota && _vm.quota.daily_use_total) || "0") +
                      "/" +
                      _vm._s((_vm.quota && _vm.quota.daily_quota) || "10") +
                      "（限时免费，每日免费搜索量" +
                      _vm._s((_vm.quota && _vm.quota.daily_quota) || "10") +
                      "条）"
                  ),
                ]
              ),
              _c(
                "span",
                { staticStyle: { color: "#9199A7", "font-size": "10px" } },
                [_vm._v("所有内容均由AI生成,仅供参考")]
              ),
            ]
          ),
        ],
        1
      ),
      _c("team-topic-modal", { ref: "teamTopicModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }